import { SettingData } from "../../shared/data/types";

interface FetchProps {
  sendRequest: (
    url: string,
    method?: string,
    body?: BodyInit,
    headers?: HeadersInit,
    successMessage?: boolean,
    zeroResultsKey?: string
  ) => Promise<any>;
}

// FETCH PLACES ////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////
interface GetUserSettingsProps extends FetchProps {
  setLoadedSettings: React.Dispatch<React.SetStateAction<SettingData>>;
  uid: string;
}

export const getUserSettings = async (props: GetUserSettingsProps) => {
  const { sendRequest, setLoadedSettings, uid } = props;

  try {
    const responseData: { settings: SettingData } = await sendRequest(
      `${process.env.REACT_APP_BACKEND_URL}/settings/user-unauth/${uid}`,
      "GET",
      null,
      {}
    );

    setLoadedSettings(responseData.settings);
  } catch (err) {}
};
